import React, { useState, useEffect } from "react";
import "./style.scss";
import Select from "react-select";
import Signature from "../../../components/Signature";
import { postData, phoneNumberFormat } from "../../../api";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import {
  mustNumberswithPhone,
  onlyCharacterWithSpace,
  emptySpace,
  onlyCharacterWithSpaceAndComma,
  autocloseTiming,
  mustNumbers,
  characterWithCommaDotHyphenAndApos,
  ssnRegex,
} from "../../../api/regex";
import { use } from "react";

const TaxInfo = ({
  nextStep,
  onboardObject,
  handleGetEmployeeData,
  stateList,
  summaryPage,
}) => {
  const [ssnNo, setSSNNo] = useState(false);
  const [einNo, setEINNo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ackShow, setAckShow] = useState(true);
  const [signatureError, setSignatureError] = useState("");
  const [signatureData, setSignatureData] = useState("");
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [fileHireShow, setFileHireShow] = useState(false);
  const [stateValue, setStateValue] = useState(null);
  const [employeeObject, setEmployeeObject] = useState({
    entity_name: "",
    soc_sec_num: "",
    federal_ein: "",
    contractor_type: "",
    file_hire_new_report: "0",
    business_name: "",
    dba_or_trade_name: "",
    taxpayer_identification_number: "",
    work_state: "" || onboardObject?.tax_info?.work_state,
    w9_agree: "off",
    signature_data: "",
    e_sign: "",
  });
  const [errors, setErrors] = useState({});

  const handleChangeSSN = () => {
    setEmployeeObject((prev) => ({
      ...prev,
      federal_ein: "",
    }));
    setSSNNo(true);
    setEINNo(false);
  };

  const handleChangeEIN = () => {
    setEmployeeObject((prev) => ({
      ...prev,
      soc_sec_num: "",
    }));
    setEINNo(true);
    setSSNNo(false);
  };

  const formatSelectOptions = (data) => {
    let finalArr = [];
    if (data && data.length > 0) {
      data.forEach((item) => {
        finalArr.push({
          value: item.name,
          label: item.name,
          name: item.name,
        });
      });
    }
    return finalArr;
  };

  const handleStateOnChange = (data) => {
    setStateValue(data);
    setEmployeeObject((prev) => ({
      ...prev,
      work_state: data.value || onboardObject?.tax_info?.work_state,
    }));
  };

  const handleW9AgreeChange = (e) => {
    const checked = e.target.checked;
    setAgreeChecked(checked);
    setEmployeeObject((prev) => ({
      ...prev,
      w9_agree: checked ? "on" : "off",
    }));
    if (errors.w9_agree) {
      setErrors({ ...errors, w9_agree: null });
    }
  };

  const handleSSNChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 9) value = value.slice(0, 9);
    if (value.length > 5) {
      value = value.replace(/^(\d{3})(\d{2})(\d{0,4}).*/, "$1-$2-$3");
    } else if (value.length > 3) {
      value = value.replace(/^(\d{3})(\d{0,2}).*/, "$1-$2");
    }
    setEmployeeObject({ ...employeeObject, soc_sec_num: value });
  };

  const handleEINChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 9) value = value.slice(0, 9);
    if (value.length > 2) {
      value = value.replace(/^(\d{2})(\d{0,7}).*/, "$1-$2");
    }
    setEmployeeObject({ ...employeeObject, federal_ein: value });
  };

  // ✅ Prefill data from onboardObject.tax_info
  useEffect(() => {
    if (onboardObject?.tax_info) {
      const info = onboardObject.tax_info;
      const matchedState = stateList.find((st) => st.name === info?.work_state);
      const formattedState =
        matchedState && matchedState.name
          ? { value: matchedState.name, label: matchedState.name }
          : info?.work_state
          ? { value: info.work_state, label: info.work_state }
          : null;

      setStateValue(formattedState);
      setSignatureData(info?.e_sign);
      setEmployeeObject((prev) => ({
        ...prev,
        entity_name: info.entity_name ?? "",
        soc_sec_num: info.ssn ?? "",
        federal_ein: info.ein ?? "",
        contractor_type: info.type?.toString() ?? "",
        file_hire_new_report: info.new_hire?.toString() ?? "",
        business_name: info.business_name ?? "",
        dba_or_trade_name: info.dba ?? "",
        taxpayer_identification_number: info.tax_identificer ?? "",
        w9_agree: info.w9_agree,
        signature_data: info.e_sign ?? "",
        e_sign: info.e_sign ?? "",
        work_state: info.work_state ?? "",
      }));

      if (info.tax_identificer === "ssn") {
        setSSNNo(true);
        setEINNo(false);
      } else if (info.tax_identificer === "ein") {
        setEINNo(true);
        setSSNNo(false);
      }
    }
  }, [onboardObject, stateList]);

  useEffect(() => {
    if (employeeObject.w9_agree === "on") {
      setAgreeChecked(true);
    } else {
      setAgreeChecked(false);
    }
  }, [employeeObject.w9_agree]);

  useEffect(() => {
    if (employeeObject.contractor_type === "1") {
      setSSNNo(true);
      setEINNo(false);
      setEmployeeObject((prev) => ({
        ...prev,
        taxpayer_identification_number: "ssn",
        federal_ein: "",
      }));
    } else if (employeeObject.contractor_type === "0") {
      setEINNo(true);
      setSSNNo(false);
      setEmployeeObject((prev) => ({
        ...prev,
        taxpayer_identification_number: "ein",
        soc_sec_num: "",
      }));
    }
  }, [employeeObject.contractor_type]);

  const findFormErrors = () => {
    const {
      entity_name,
      soc_sec_num,
      federal_ein,
      contractor_type,
      file_hire_new_report,
      dba_or_trade_name,
      taxpayer_identification_number,
    } = employeeObject;
    const newErrors = {};

    if (!entity_name || entity_name.trim() === "") {
      newErrors.entity_name = "Please enter the entity name";
    } else if (entity_name.length < 3 || entity_name.length > 70) {
      newErrors.entity_name =
        "The entity name should be  3 to 70 characters long.";
    } else if (
      !entity_name.match(emptySpace) ||
      !entity_name.match(onlyCharacterWithSpace)
    ) {
      newErrors.entity_name = "The entity name should be alphabetic.";
    }

    if (
      !contractor_type ||
      (contractor_type !== "0" && contractor_type !== "1")
    ) {
      newErrors.contractor_type = "Please select a type";
    }

    if (!dba_or_trade_name || dba_or_trade_name.trim() === "") {
      newErrors.dba_or_trade_name = "Please enter the entity name";
    } else if (dba_or_trade_name.length < 3 || dba_or_trade_name.length > 70) {
      newErrors.dba_or_trade_name =
        "The entity name should be  3 to 70 characters long.";
    } else if (
      !dba_or_trade_name.match(emptySpace) ||
      !dba_or_trade_name.match(onlyCharacterWithSpace)
    ) {
      newErrors.dba_or_trade_name = "The entity name should be alphabetic.";
    }

    if (
      !taxpayer_identification_number ||
      (taxpayer_identification_number !== "ssn" &&
        taxpayer_identification_number !== "ein")
    ) {
      newErrors.taxpayer_identification_number = "Please select an option";
    }

    if (ssnNo === true && taxpayer_identification_number === "ssn") {
      if (!soc_sec_num || soc_sec_num.trim() === "") {
        newErrors.soc_sec_num = "Please enter the SSN number";
      } else if (!soc_sec_num.match(ssnRegex)) {
        newErrors.soc_sec_num = "Please enter a valid SSN number";
      }
    }

    if (einNo === true && taxpayer_identification_number === "ein") {
      if (!federal_ein || federal_ein.trim() === "") {
        newErrors.federal_ein = "Please enter the EIN number";
      } else if (!mustNumbers.test(federal_ein)) {
        newErrors.federal_ein = "Please enter a valid EIN number";
      }
    }

    if (!stateValue || !stateValue.value) {
      newErrors.work_state = "Please select an option";
    }

    if (signatureData === "" || !signatureData) {
      setSignatureError("Please add the signature");
    } else {
      setSignatureError("");
    }

    if (!agreeChecked) {
      newErrors.w9_agree = "Please select an option";
    }

    return newErrors;
  };

  useEffect(() => {
    if (employeeObject?.contractor_type === "1") {
      setFileHireShow(true);
    } else {
      setFileHireShow(false);
    }
  }, [employeeObject?.contractor_type]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEmployeeObject((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      taxInfoStep();
    }
  };

  const taxInfoStep = async () => {
    setLoading(true);
    let data = { ...employeeObject };
    if (employeeObject.contractor_type === "1") {
      data.file_hire_new_report = "0";
    } else if (employeeObject.contractor_type === "0") {
      data.file_hire_new_report = employeeObject.file_hire_new_report || "";
    }
    if (data.contractor_type === "0" && data.dba_or_trade_name) {
      data.business_name = data.dba_or_trade_name;
    }
    ["federal_ein", "soc_sec_num"].forEach((f) => {
      if (data[f] && typeof data[f] === "string") {
        data[f] = data[f].replace(/-/g, "");
      }
    });
    const res = await postData("tax-gusto-contractor", {}, data);
    if (res.status === true) {
      setLoading(false);
      nextStep(res.next_steps);
      handleGetEmployeeData();
    } else {
      toast.error(res.message, {
        theme: "colored",
        autoClose: autocloseTiming,
      });
      setLoading(false);
    }
  };

  const acknowledgeShow = (data) => {
    setAckShow(data);
  };

  const signatureObj = (data) => {
    if (!data?.drawSign && !data?.uploadSign) {
      setAckShow(true);
    } else {
      const signValue = data?.drawSign || data?.uploadSign?.[0];
      if (signValue) {
        setEmployeeObject((prev) => ({
          ...prev,
          signature_data: signValue,
          e_sign: signValue,
        }));
        setSignatureData({ signature_data: signValue });
        setErrors({ ...errors, signature_data: null });
      }
    }
  };
  return (
    <>
      {!loading && (
        <div className="tax-info-container">
          <div className="tax-info-title-wrapper">
            <h2>Tax Information</h2>
          </div>
          <form className="tax-info-form">
            <div className="form-row form-row-1">
              <div className="form-column">
                <div className="form-group">
                  <label htmlFor="entity_name">
                    Entity name <span className="asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entity_name"
                    name="entity_name"
                    placeholder="Enter entity name"
                    value={employeeObject.entity_name}
                    onChange={handleInput}
                    disabled={summaryPage}
                  />
                  {errors.entity_name && (
                    <p className="field-error">{errors.entity_name}</p>
                  )}
                </div>
              </div>
              <div className="form-column">
                <div className="form-group">
                  <p className="form-label">
                    Type <span className="asterisk">*</span>
                  </p>
                  <div className="form-sub-group">
                    <div className="sub-group">
                      <input
                        type="radio"
                        id="individual"
                        name="contractor_type"
                        value="1"
                        onChange={handleInput}
                        checked={employeeObject.contractor_type === "1"}
                        disabled={summaryPage}
                      />
                      <label htmlFor="individual">Individual</label>
                    </div>
                    <div className="sub-group">
                      <input
                        type="radio"
                        id="business"
                        name="contractor_type"
                        value="0"
                        onChange={handleInput}
                        checked={employeeObject.contractor_type === "0"}
                        disabled={summaryPage}
                      />
                      <label htmlFor="business">Business</label>
                    </div>
                  </div>
                  {errors.contractor_type && (
                    <p className="field-error">{errors.contractor_type}</p>
                  )}
                </div>
              </div>
              <div className="form-column">
                <div className="form-group">
                  <label htmlFor="dba_or_trade_name">
                    DBA or Trade name <span className="asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="dba_or_trade_name"
                    name="dba_or_trade_name"
                    placeholder="Enter dba or trade name"
                    value={employeeObject.dba_or_trade_name}
                    onChange={handleInput}
                    disabled={summaryPage}
                  />
                  {errors.dba_or_trade_name && (
                    <p className="field-error">{errors.dba_or_trade_name}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="form-row form-row-2">
              <div className="form-column">
                <div className="form-group">
                  <p className="form-label">
                    Taxpayer Identification Number{" "}
                    <span className="asterisk">*</span>
                  </p>
                  <div className="form-sub-group">
                    <div className="sub-group">
                      <input
                        type="radio"
                        id="ssn"
                        name="taxpayer_identification_number"
                        value="ssn"
                        onChange={(e) => {
                          handleChangeSSN(e);
                          handleInput(e);
                        }}
                        checked={
                          employeeObject.taxpayer_identification_number ===
                          "ssn"
                        }
                        disabled={summaryPage || !ssnNo}
                      />
                      <label htmlFor="ssn">SSN</label>
                    </div>
                    <div className="sub-group">
                      <input
                        type="radio"
                        id="ein"
                        name="taxpayer_identification_number"
                        value="ein"
                        onChange={(e) => {
                          handleChangeEIN(e);
                          handleInput(e);
                        }}
                        checked={
                          employeeObject.taxpayer_identification_number ===
                          "ein"
                        }
                        disabled={summaryPage || !einNo}
                      />
                      <label htmlFor="ein">EIN</label>
                    </div>
                  </div>
                  {errors.taxpayer_identification_number && (
                    <p className="field-error">
                      {errors.taxpayer_identification_number}
                    </p>
                  )}
                </div>
              </div>
              {ssnNo && (
                <div className="form-column">
                  <div className="form-group">
                    <label htmlFor="soc_sec_num">Social Security Number</label>
                    <input
                      type="text"
                      className="form-control"
                      id="soc_sec_num"
                      name="soc_sec_num"
                      placeholder="Enter ssn number"
                      value={employeeObject.soc_sec_num}
                      onChange={handleSSNChange}
                      disabled={summaryPage}
                    />
                    {errors.soc_sec_num && (
                      <p className="field-error">{errors.soc_sec_num}</p>
                    )}
                  </div>
                </div>
              )}
              {einNo && (
                <div className="form-column">
                  <div className="form-group">
                    <label htmlFor="federal_ein">
                      Employee Identification Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="federal_ein"
                      name="federal_ein"
                      placeholder="Enter ein number"
                      value={employeeObject.federal_ein}
                      onChange={handleEINChange}
                      disabled={summaryPage}
                    />
                    {errors.federal_ein && (
                      <p className="field-error">{errors.federal_ein}</p>
                    )}
                  </div>
                </div>
              )}
              <div className="form-column">
                <div className="form-group">
                  <label htmlFor="work_state">
                    Work State <span className="asterisk">*</span>
                  </label>
                  <div
                    className={`form-select-box ${
                      summaryPage ? "disabled-select" : ""
                    }`}
                  >
                    <Select
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      options={formatSelectOptions(stateList)}
                      onChange={(selectedOption) =>
                        handleStateOnChange(selectedOption)
                      }
                      name="work_state"
                      id="work_state"
                      value={stateValue}
                      placeholder={"Select state"}
                      isDisabled={summaryPage}
                    />
                  </div>
                  {stateValue === undefined && errors.work_state && (
                    <p className="field-error">{errors.work_state}</p>
                  )}
                </div>
              </div>
            </div>

            <div
              className={
                fileHireShow
                  ? "form-row form-row-3 disabled"
                  : `form-row form-row-3`
              }
            >
              <div className="form-column flex-full">
                <h4 className="form-title">File new Hire Report?</h4>
                <p className="form-subtitle">
                  State law requires you to file a new hire report within 20
                  days of hiring or re-hiring an employee.
                </p>
                <div className="form-group">
                  <div className="form-sub-group">
                    <div className="sub-group flex-full">
                      <input
                        type="radio"
                        id="yes"
                        name="file_hire_new_report"
                        value="1"
                        onChange={handleInput}
                        disabled={summaryPage}
                        checked={employeeObject.file_hire_new_report === "1"}
                      />
                      <label htmlFor="yes">
                        Yes, file the state new hire report for me.
                      </label>
                    </div>
                    <div className="sub-group flex-full">
                      <input
                        type="radio"
                        id="no"
                        name="file_hire_new_report"
                        value="0"
                        onChange={handleInput}
                        disabled={summaryPage}
                        checked={
                          employeeObject.file_hire_new_report === "0" ||
                          !employeeObject.file_hire_new_report
                        }
                      />
                      <label htmlFor="no">No, I have already filed.</label>
                    </div>
                  </div>
                  {errors.file_hire_new_report && (
                    <p className="field-error">{errors.file_hire_new_report}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-row form-row-4">
              <div className="form-column flex-full">
                <div className="form-group">
                  <div className="form-sub-group">
                    <div className="sub-group">
                      <input
                        type="checkbox"
                        id="w9_agree"
                        name="w9_agree"
                        onChange={handleW9AgreeChange}
                        checked={agreeChecked}
                        disabled={summaryPage}
                      />
                      <label htmlFor="w9_agree">
                        I agree to all tax regulations as proposed in the
                        <a href=""> W-9 Form</a>
                      </label>
                    </div>
                  </div>
                  {!agreeChecked && (
                    <p className="field-error">{errors.w9_agree}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-row form-row-5">
              <div className="form-column flex-full">
                <Signature
                  className="mb-3"
                  acknowledgeShow={acknowledgeShow}
                  signatureObj={signatureObj}
                  signatureError={signatureError}
                  setSignatureError={setSignatureError}
                  eSign={employeeObject?.e_sign}
                  summaryPage={summaryPage}
                />
              </div>
            </div>
            {summaryPage ? null : (
              <div className="form-row form-row-6">
                <div className="form-column flex-full button-flex-wrapper">
                  <button
                    type="button"
                    className="previous-btn"
                    onClick={() => nextStep("personal_info")}
                  >
                    Previous
                  </button>
                  <button
                    type="submit"
                    className="submit-btn"
                    onClick={handleSubmit}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      )}
      {loading && <Loader />}
    </>
  );
};

export default TaxInfo;
